var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper"},[_c('Layout',[_c('common-header'),_c('keep-alive',[_c('router-view',{attrs:{"name":"content"}})],1),_c('common-footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }